module.exports = __webpack_public_path__ + "static/img/s6.c08ae5d6.png";